import React from 'react';
import is from 'is_js';
import PropTypes from 'prop-types';
import BaseSessionNav from 'components/BaseSessionNav';
import QuickSummary from 'components/QuickSummary';
import { connect } from 'omni-common-ui';

const DATE_FORMAT = 'YYYY-MM-DD';
const TIME_FORMAT = 'HH:mm';

class ClassroomSessionNav extends BaseSessionNav {
  _hasNext() {
    return this.props.currentSessionNumber !== this.props.sessionCount;
  }

  _hasPrevious() {
    return this.props.currentSessionNumber > 1;
  }

  _hasNextUnit() {
    return is.existy(this.props.nextUnitText);
  }

  _hasPreviousUnit() {
    return is.existy(this.props.previousUnitText);
  }

  _getTimeFormat(moment) {
    return moment.format(TIME_FORMAT);
  }

  _getHeadingText() {
    const { currentSessionStartDate, currentSessionEndDate, shouldShowTime } = this.props;
    const date = currentSessionStartDate.format(DATE_FORMAT);
    const time = `${this._getTimeFormat(currentSessionStartDate)}-${this._getTimeFormat(currentSessionEndDate)}`;
    const dateTime = is.boolean(shouldShowTime) && shouldShowTime ? `${date} ${time}` : date;
    return <time dateTime={dateTime}>
      {dateTime}
    </time>;
  }

  _getNextUnitText() {
    return this.props.nextUnitText;
  }

  _getPreviousUnitText() {
    return this.props.previousUnitText;
  }

  _getCurrentUnitInfo() {
    if (this.props.currentUnit) {
      return `, ${this.props.currentUnit.name}`;
    }
  }

  _getAdditionalChildren() {
    return <h2>
      <QuickSummary type={QuickSummary.Type.attendance}
          currentUnit={this.props.currentUnit}
          entityId={this.props.currentSessionId}
          sessionCount={this.props.sessionCount} />
    </h2>;
  }
}

ClassroomSessionNav.propTypes = Object.assign({
  currentSessionStartDate: PropTypes.object.isRequired,
  currentSessionEndDate: PropTypes.object.isRequired,
  currentUnit: PropTypes.object.isRequired,
  currentSessionId: PropTypes.string,
  currentGroupName: PropTypes.string,
  nextUnitText: PropTypes.string,
  previousUnitText: PropTypes.string,
  shouldShowTime: PropTypes.bool,
}, BaseSessionNav.propTypes);

export default connect(null, null)(ClassroomSessionNav);



// WEBPACK FOOTER //
// ./components/ClassroomSessionNav/index.jsx